import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="app-header">
      <div className="container header-container">
        <div className="logo-area">
          {/* Les images dans public/ sont accessibles via process.env.PUBLIC_URL */}
          <img src={process.env.PUBLIC_URL + '/images/logo.jpg'} alt="Info-Alt Logo" className="logo-img" />
          <div className="logo-text">
            <h1>Info-Alt</h1>
            <p className="tagline">Informatique à Lombez</p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;